import { adSlotPrebid, psConf, pubStackConf } from "../../conf/adUnitsConf"

export interface PreBidderjsConfig {
    bidder: string;
    code?: string
    params: {
        adSlot?: string;
        publisherId?: string;
        apiKey?: string
        pubid?: string;
        networkId?: number | string;
        kadfloor?: string;
        currency?: string;
        placementId?: number;
        placement_id?: number;
        zoneId?: string
        siteId?: string
        host?: string
        tagId?: string
        //freewheel
        serverUrl?: string;
        profile?: string;
        siteSectionId?: string;
        videoAssetId?: string;
        bidfloor?: number;
        bidfloorcur?: string;
        flags?: string;
        adRequestKeyValues?: Record<string, any>;
        timePosition?: number,
        adUnitName?: string,
        placement?: string,
        supplySourceId?: string;
        mode?: string;
    };
    ortb2Imp?: {
        instl?: number
        ext?: {
            gpid?: string
        },
        data?: {
            pbadslot: string
        }
    },
}

export type videoType = 'instream' | 'outstream'

interface prebidVideoParams {
    playbackmethod?: number[]
}

export interface basePrebidSlots {
    sizes: Array<[number, number] | 'fluid'>;
    id: string,
    adunitId: string,
    videoParams?: prebidVideoParams
}

interface mediaTypesPrebid {
    banner?: BannerPrebidConfig,
    video?: VideoPrebidConfig
}

interface BannerPrebidConfig {
    sizes: [number, number][]
}
interface VideoPrebidConfig {
    playerSize: [number, number] | [number, number][];
    context: videoType, //instream or outstream
    mimes: string[], //elenco mime type
    api: number[], //formati video accettati
    //----------------------------------
    plcmt: number, //1 = instram
    pos: number,  //posizione in pagina 1=above the fold
    skip: number, //1 = skippable
    linearity: number, //1 occupa tutto il layer, 2 altri formati (overlay, companion)
    skipafter: number, // dopo quanti secondi è skippable
    skippable: boolean, // se skippabile
    playbackmethod: number[], //modalita erogazione 1= autoplay + audio attivo, 2 autoplay con audio off 
    maxduration?: number,
    minduration?: number,
    //----------------------------
    startdelay: number
    protocols: number[], // elenco versioni vast
    placement: number,
    minbitrate: number,
    maxbitrate: number,
}

export interface PrebidjsSlot {
    code: string;
    mediaTypes: mediaTypesPrebid
    bids: PreBidderjsConfig[],
    ortb2Imp?: object //parametri video per campagne open dirette
}

export class DigestConf {
    private window: any
    private mainSite: string = ''
    private site: string = ''
    private mobile: boolean = false

    constructor(win: any) {
        this.window = win
        this.mobile = this.window.uaDetect().device && this.window.uaDetect().device.phone ? this.window.uaDetect().device.phone : false
        this.mainSite = win.cp_ads_config.targets.find((item: { key: string; }) => item.key === 'site')?.value
        this.site = win.cp_ads_config.targets.find((item: { key: string; }) => item.key === this.mainSite) ? win.cp_ads_config.targets.find((item: { key: string; }) => item.key === this.mainSite)?.value : this.mainSite
    }

    private isTargetPostId(): boolean {
        return typeof this.window.document !== 'undefined' && this.window.document.body && this.window.document.body.classList.contains('postid-121224');
    }

    public getPubstackConf(): psConf | null {
        if (this.site === 'napoli') return null
        return pubStackConf[this.mainSite] ? pubStackConf[this.mainSite] : null
    }

    private instreamVideoCase(adunitId: string, id?: string): PreBidderjsConfig[] {

        let ttd: PreBidderjsConfig | null = adSlotPrebid.ttd.video[adunitId] ? {
            bidder: 'ttd',
            params: {
                supplySourceId: adSlotPrebid.ttd.video[adunitId].supplySourceId,
                placementId: adSlotPrebid.ttd.video[adunitId].placementId,
                publisherId: '1'
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.ttd.video[adunitId].placementId
                }
            }
        } : null

        let apnxcnf: PreBidderjsConfig | null = adSlotPrebid.appnexus.video[adunitId] ? {
            bidder: 'msft',
            params: {
                placement_id: adSlotPrebid.appnexus.video[adunitId].placementId
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.appnexus.video[adunitId].gpid
                }
            }
        } : null

        var freewheel: PreBidderjsConfig | null = adSlotPrebid.fw.video[adunitId] || this.isTargetPostId() ? {
            bidder: 'fwssp',
            params: this.isTargetPostId() ? {
                serverUrl: 'https://179ed.v.fwmrm.net/ad/g/1',
                networkId: '96749',
                profile: '96749:prebidjs_test',
                siteSectionId: 'PrebidJS_demo',
                flags: '+fwssp+amcb+nucr',
                mode: 'on-demand',
                videoAssetId: '0',
                adRequestKeyValues: {
                    _fw_h_user_agent: navigator.userAgent,
                    _fw_player_width: '640',
                    _fw_player_height: '480',
                    tpcl: 'PREROLL',
                    ptgt: 'a',
                    mind: '15',
                    maxd: '60'
                }
            } : {
                serverUrl: "https://82df6.v.fwmrm.net/ad/g/1",
                networkId: adSlotPrebid.fw.video[adunitId].networkId,
                profile: adSlotPrebid.fw.video[adunitId].profile,
                siteSectionId: adSlotPrebid.fw.video[adunitId].siteSectionId,
                //flags: '+play',
                //flags: '+fwssp+amcb+nucr',
                videoAssetId: '0',
                //timePosition: 120,
                //mode: 'on-demand',
                //bidfloor: 0.20,
                //bidfloorcur: 'EUR',
                adRequestKeyValues: {
                    _fw_site_page: window.location.host,
                    _fw_platform_weborapp: 'web',
                    _fw_content_language: 'IT',
                    _fw_content_genre: 'News',
                    _fw_content_category: 'IAB20',
                    _fw_content_programmer: 'CiaoPeople',
                    _fw_content_programmer_brand: 'Fanpage',
                    _fw_content_producer_name: 'CiaoPeople',
                    _fw_content_programmer_brand_channel: 'Fanpage'
                    //tpcl: 'PREROLL',
                    //ptgt: 'a',
                    //mind: '15',
                    //maxd: '60',
                    //_fw_h_user_agent: navigator.userAgent,
                }
            }
        } : null

        let seedtag: PreBidderjsConfig | null = adSlotPrebid.seedtag.video[adunitId].publisherId ? {
            bidder: 'seedtag',
            params: {
                ...adSlotPrebid.seedtag.video[adunitId]
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.seedtag.video[adunitId].gpid
                },
                data: {
                    pbadslot: adSlotPrebid.seedtag.video[adunitId].gpid
                }
            }
        } : null

        let pubmaticcnf: PreBidderjsConfig | null = adSlotPrebid.pubmatic_apex.video[adunitId] ? {
            bidder: 'pubmatic_apex',
            params: {
                ...adSlotPrebid.pubmatic_apex.video[adunitId],
            },
        } : null

        let pubmcnf: PreBidderjsConfig | null = adSlotPrebid.pubmatic.video[adunitId] ? {
            bidder: 'pubmatic',
            params: {
                ...adSlotPrebid.pubmatic.video[adunitId],
            },
        } : null

        let improvecnf: PreBidderjsConfig | null = adSlotPrebid.improve.video[adunitId] ? {
            bidder: 'improvedigital',
            params: {
                ...adSlotPrebid.improve.video[adunitId],
            },
        } : null

        let rubiconcnf = adSlotPrebid.rubicon.video[adunitId] ? {
            bidder: 'rubicon',
            params: {
                ...adSlotPrebid.rubicon.video[adunitId],
            },
        } : null

        let ix: PreBidderjsConfig | null = adSlotPrebid.ix.video[adunitId] && adSlotPrebid.ix.video[adunitId].siteId ? {
            bidder: 'ix',
            params: {
                siteId: adSlotPrebid.ix.video[adunitId].siteId
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.ix.video[adunitId].gpid
                }
            }
        } : null

        // let yobee: PreBidderjsConfig | null = adSlotPrebid.yobee.video[adunitId] ? {
        //     bidder: 'yobee',
        //     params: {
        //         networkId: adSlotPrebid.yobee.video[adunitId].networkId,
        //         host: adSlotPrebid.yobee.video[adunitId].host
        //     },
        //     ortb2Imp: {
        //         ext: {
        //             gpid: adSlotPrebid.yobee.video[adunitId].gpid
        //         }
        //     }
        // } : null

        let pubstack: PreBidderjsConfig | null = (adSlotPrebid.pubstack.video[adunitId] && this.site !== 'napoli') ? {
            bidder: 'pubstack_server',
            code: id,
            params: {
                adUnitName: adSlotPrebid.pubstack.video[adunitId].adUnit
            }
        } : null

        let ozone: PreBidderjsConfig | null = adSlotPrebid.ozone.video[adunitId] && adSlotPrebid.ozone.video[adunitId].publisherId ? {
            bidder: 'ozone',
            params: {
                publisherId: adSlotPrebid.ozone.video[adunitId].publisherId,
                siteId: adSlotPrebid.ozone.video[adunitId].siteId,
                placementId: adSlotPrebid.ozone.video[adunitId].placementId,
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.ozone.video[adunitId].gpid
                },
                data: {
                    pbadslot: adSlotPrebid.ozone.video[adunitId].gpid
                }
            }
        } : null

        if (this.isTargetPostId()) {
            return freewheel ? [freewheel] : []
        }

        let bidsConf: PreBidderjsConfig[] = []
        if (apnxcnf) bidsConf.push(apnxcnf)
        if (pubmaticcnf) bidsConf.push(pubmaticcnf)
        if (rubiconcnf) bidsConf.push(rubiconcnf)
        if (ttd) bidsConf.push(ttd)
        let randomizableBidders: PreBidderjsConfig[] = [];
        if (pubmcnf) randomizableBidders.push(pubmcnf)
        if (freewheel) randomizableBidders.push(freewheel)
        if (improvecnf) randomizableBidders.push(improvecnf)
        if (seedtag) randomizableBidders.push(seedtag)
        if (ix) randomizableBidders.push(ix)
        // if (yobee) randomizableBidders.push(yobee)
        if (pubstack) randomizableBidders.push(pubstack)
        if (ozone) randomizableBidders.push(ozone)


        this.shuffleArray(randomizableBidders)
        bidsConf.push(...randomizableBidders)
        console.log('[PREBID] Video Bidders Order:');
        bidsConf.forEach((bidder, index) => {
            console.log(`  ${index + 1}. ${bidder.bidder}: ${JSON.stringify(bidder)}`);
        });
        return bidsConf
    }

    private shuffleArray(array: PreBidderjsConfig[]): void {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }


    private displayCase(adunitId: string, id?: string): PreBidderjsConfig[] {
        if (((this.site != 'napoli' && this.site != 'milano' && this.site != 'roma') || !this.mobile) && adunitId == 'overlayer') {
            adSlotPrebid.missena.display[adunitId] = undefined;
            adSlotPrebid.appnexus.display[adunitId] = undefined;
        }


        let ttd: PreBidderjsConfig | null = adSlotPrebid.ttd.display[adunitId] ? {
            bidder: 'ttd',
            params: {
                placementId: adSlotPrebid.ttd.display[adunitId].placementId,
                supplySourceId: adSlotPrebid.ttd.display[adunitId].supplySourceId,
                publisherId: '1'
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.ttd.display[adunitId].placementId
                },
                data: {
                    pbadslot: adSlotPrebid.ttd.display[adunitId].placementId
                }
            }
        } : null

        let missena: PreBidderjsConfig | null = adSlotPrebid.missena.display[adunitId] ? {
            bidder: 'missena',
            params: {
                apiKey: adSlotPrebid.missena.display[adunitId].apiKey,
                placement: adSlotPrebid.missena.display[adunitId].placement
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.missena.display[adunitId].gpid
                },
                data: {
                    pbadslot: adSlotPrebid.missena.display[adunitId].gpid
                }
            }
        } : null;

        let pbmaticnf: PreBidderjsConfig | null = (adSlotPrebid.pubmatic.display[adunitId] && adSlotPrebid.pubmatic.display[adunitId].publisherId) ? {
            bidder: 'pubmatic',
            params: {
                publisherId: adSlotPrebid.pubmatic.display[adunitId].publisherId,
                adSlot: adSlotPrebid.pubmatic.display[adunitId].adSlot,
            }
        } : null
        let pbmaticapexcnf: PreBidderjsConfig | null = (adSlotPrebid.pubmatic_apex.display[adunitId] && adSlotPrebid.pubmatic_apex.display[adunitId].publisherId) ? {
            bidder: 'pubmatic_apex',
            params: {
                publisherId: adSlotPrebid.pubmatic_apex.display[adunitId].publisherId,
                adSlot: adSlotPrebid.pubmatic_apex.display[adunitId].adSlot,
            }
        } : null
        let apnxcnf: PreBidderjsConfig | null = adSlotPrebid.appnexus.display[adunitId] && adSlotPrebid.appnexus.display[adunitId].placementId ? {
            bidder: 'msft',
            params: {
                placement_id: adSlotPrebid.appnexus.display[adunitId].placementId
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.appnexus.display[adunitId].gpid
                },
                data: {
                    pbadslot: adSlotPrebid.appnexus.display[adunitId].gpid
                }
            }
        } : null
        //TODO gestire meglio segnali openrtb2
        if (apnxcnf && apnxcnf.ortb2Imp && adSlotPrebid.appnexus.display[adunitId].instl) apnxcnf.ortb2Imp.instl = adSlotPrebid.appnexus.display[adunitId].instl

        let taboolacnf: PreBidderjsConfig | null = (adSlotPrebid.taboola.display[adunitId] && adSlotPrebid.taboola.display[adunitId].publisherId) ? {
            bidder: 'taboola',
            params: {
                publisherId: adSlotPrebid.taboola.display[adunitId].publisherId,
                tagId: adunitId,
            }
        } : null
        let rubiconcnf: PreBidderjsConfig | null = (adSlotPrebid.rubicon.display[adunitId]) ? {
            bidder: 'rubicon',
            params: {
                ...adSlotPrebid.rubicon.display[adunitId],
            }
        } : null
        let seedtag: PreBidderjsConfig | null = adSlotPrebid.seedtag.display[adunitId] ? {
            bidder: 'seedtag',
            params: {
                ...adSlotPrebid.seedtag.display[adunitId]
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.seedtag.display[adunitId].gpid
                },
                data: {
                    pbadslot: adSlotPrebid.seedtag.display[adunitId].gpid
                }
            }
        } : null

        // let ogury: PreBidderjsConfig | null = adSlotPrebid.ogury.display[adunitId] ? {
        //     bidder: 'ogury',
        //     params: {
        //         ...adSlotPrebid.ogury.display[adunitId]
        //     },
        //     ortb2Imp: {
        //         ext: {
        //             gpid: adSlotPrebid.ogury.display[adunitId].gpid
        //         },
        //         data: {
        //             pbadslot: adSlotPrebid.ogury.display[adunitId].gpid
        //         }
        //     }
        // } : null

        let ozone: PreBidderjsConfig | null = adSlotPrebid.ozone.display[adunitId] && adSlotPrebid.ozone.display[adunitId].publisherId ? {
            bidder: 'ozone',
            params: {
                publisherId: adSlotPrebid.ozone.display[adunitId].publisherId,
                siteId: adSlotPrebid.ozone.display[adunitId].siteId,
                placementId: adSlotPrebid.ozone.display[adunitId].placementId,
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.ozone.display[adunitId].gpid
                },
                data: {
                    pbadslot: adSlotPrebid.ozone.display[adunitId].gpid
                }
            }
        } : null

        let pubstack: PreBidderjsConfig | null = (adSlotPrebid.pubstack.display[adunitId] && this.site !== 'napoli') ? {
            bidder: 'pubstack_server',
            code: id,
            params: {
                adUnitName: adSlotPrebid.pubstack.display[adunitId].adUnit
            },
        } : null

        // let yobee: PreBidderjsConfig | null = adSlotPrebid.yobee.display[adunitId] ? {
        //     bidder: 'yobee',
        //     params: {
        //         networkId: adSlotPrebid.yobee.display[adunitId].networkId,
        //         host: adSlotPrebid.yobee.display[adunitId].host
        //     },
        //     ortb2Imp: {
        //         ext: {
        //             gpid: adSlotPrebid.yobee.display[adunitId].gpid
        //         },
        //         data: {
        //             pbadslot: adSlotPrebid.yobee.display[adunitId].gpid
        //         }
        //     }
        // } : null

        let ix: PreBidderjsConfig | null = adSlotPrebid.ix.display[adunitId] && adSlotPrebid.ix.display[adunitId].siteId ? {
            bidder: 'ix',
            params: {
                siteId: adSlotPrebid.ix.display[adunitId].siteId
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.ix.display[adunitId].gpid
                }
            }
        } : null

        let mobkoi: PreBidderjsConfig | null = adSlotPrebid.mobkoi.display[adunitId] && adSlotPrebid.mobkoi.display[adunitId].placementId ? {
            bidder: 'mobkoi',
            params: {
                placementId: adSlotPrebid.mobkoi.display[adunitId].placementId
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.mobkoi.display[adunitId].gpid
                }
            }
        } : null

        let connectAd: PreBidderjsConfig | null = adSlotPrebid.connectAd.display[adunitId] && adSlotPrebid.connectAd.display[adunitId].siteId ? {
            bidder: 'connectad',
            params: {
                siteId: adSlotPrebid.connectAd.display[adunitId].siteId,
                networkId: adSlotPrebid.connectAd.display[adunitId].networkId
            },
            ortb2Imp: {
                ext: {
                    gpid: adSlotPrebid.connectAd.display[adunitId].gpid
                }
            }
        } : null

        let fwssp: PreBidderjsConfig | null = (adunitId === 'go_interstitial' && this.isTargetPostId()) ? {
            bidder: 'fwssp',
            params: {
                serverUrl: 'https://179ed.v.fwmrm.net/ad/g/1',
                networkId: '96749',
                profile: '96749:prebidjs_test',
                siteSectionId: 'PrebidJS_demo',
                flags: '+fwssp+amcb+nucr',
                mode: 'on-demand',
                videoAssetId: '0',
                adRequestKeyValues: {
                    _fw_h_user_agent: navigator.userAgent,
                    _fw_player_width: '640',
                    _fw_player_height: '480',
                    tpcl: 'PREROLL',
                    ptgt: 'a',
                    mind: '15',
                    maxd: '60'
                }
            }
        } : null

        let bidsConf: PreBidderjsConfig[] = []
        if (seedtag) bidsConf.push(seedtag)
        // if (ogury) bidsConf.push(ogury)
        if (rubiconcnf) bidsConf.push(rubiconcnf)
        if (apnxcnf) bidsConf.push(apnxcnf)
        if (pubstack) bidsConf.push(pubstack)
        if (missena) bidsConf.push(missena)
        if (ttd) bidsConf.push(ttd)
        if (connectAd) bidsConf.push(connectAd)
        if (fwssp) bidsConf.push(fwssp)
        let randomizableBidders: PreBidderjsConfig[] = []
        if (pbmaticnf) randomizableBidders.push(pbmaticnf)
        if (pbmaticapexcnf) randomizableBidders.push(pbmaticapexcnf)
        if (taboolacnf) randomizableBidders.push(taboolacnf)
        if (ix) randomizableBidders.push(ix)
        if (mobkoi) randomizableBidders.push(mobkoi)
        // if (yobee) randomizableBidders.push(yobee)
        if (ozone) randomizableBidders.push(ozone)

        this.shuffleArray(randomizableBidders)
        bidsConf.push(...randomizableBidders)

        console.log('[PREBID] Display Bidders Order:');
        bidsConf.forEach((bidder, index) => {
            console.log(`  ${index + 1}. ${bidder.bidder}: ${JSON.stringify(bidder)}`);
        });
        return bidsConf
    }


    private addGPID(adunitId: string): { ext: { gpid: string } } | undefined {
        const gpid =
            adSlotPrebid.ix.video[adunitId]?.gpid ||
            adSlotPrebid.ix.display[adunitId]?.gpid

        return gpid ? { ext: { gpid } } : undefined
    }

    private isOutstreamDisplay(adunitId: string): boolean {
        const displayMaps = [
            adSlotPrebid.appnexus.display,
            adSlotPrebid.pubmatic.display,
            adSlotPrebid.pubmatic_apex.display,
            adSlotPrebid.taboola.display,
            adSlotPrebid.rubicon.display,
            adSlotPrebid.seedtag.display,
            adSlotPrebid.ix.display,
            adSlotPrebid.criteo.display,
            adSlotPrebid.mobkoi.display,
            adSlotPrebid.yobee.display,
            adSlotPrebid.ogury.display,
            adSlotPrebid.pubstack.display,
            adSlotPrebid.missena.display,
            adSlotPrebid.ttd.display,
            adSlotPrebid.connectAd.display,
            adSlotPrebid.ozone.display
        ]

        return displayMaps.some((map) => map?.[adunitId]?.outstream === 1)
    }



    public preparePrebidSlots(slots: basePrebidSlots[]): Promise<PrebidjsSlot[]> {
        const preSlots: PrebidjsSlot[] = []

        for (const s of slots) {
            let { id, sizes, adunitId } = s
            const szsAll: Array<[number, number] | 'fluid'> = sizes
            const bannerSizes: [number, number][] = szsAll.filter(
                (it): it is [number, number] => Array.isArray(it)
            )

            adunitId = adunitId.replace('/1010633/', '')

            const isInstream = adunitId.includes("_video")
            const isOutstream = !isInstream && this.isOutstreamDisplay(adunitId)

            let bidsConf: PreBidderjsConfig[] = []

            if (isInstream) {
                bidsConf = this.instreamVideoCase(adunitId, id)
            } else {
                bidsConf = this.displayCase(adunitId, id)
            }

            if (!bidsConf.length) continue

            const toPush: PrebidjsSlot = {
                code: id,
                mediaTypes: {},
                bids: bidsConf
            }

            if (isInstream || isOutstream) {
                const numericSizes: [number, number][] = szsAll.filter(
                    (it): it is [number, number] => Array.isArray(it)
                )

                var playerSize: [number, number] | [number, number][] =
                    numericSizes.length <= 1
                        ? (numericSizes[0] ?? [640, 480])
                        : numericSizes

                const context: videoType = isInstream ? 'instream' : 'outstream'

                playerSize = context === 'outstream' ? [[640, 480]] : playerSize

                toPush.mediaTypes.video = {
                    playerSize,
                    context,
                    mimes: ['video/mp4', 'video/webm', 'application/javascript'],
                    api: [1, 2, 3, 4, 5, 6, 7, 8],

                    plcmt: isInstream ? 1 : 4,
                    pos: 1,
                    skip: 1,
                    linearity: 1,
                    skipafter: 5,
                    skippable: true,
                    playbackmethod: s.videoParams?.playbackmethod ?? [1, 2, 3, 4, 5, 6],
                    maxduration: 30,
                    minduration: 5,
                    startdelay: 0,
                    protocols: [1, 2, 3, 5, 6, 7, 8, 11, 12, 13, 14],
                    placement: isInstream ? 1 : 4,
                    minbitrate: 300,
                    maxbitrate: 9600,
                }

                // Outstream è sempre multiformat: banner + video
                if (isOutstream && bannerSizes.length > 0) {
                    toPush.mediaTypes.banner = { sizes: bannerSizes }
                }

                if (isInstream && adSlotPrebid.appnexus.code?.[adunitId]) {
                    toPush.code = adSlotPrebid.appnexus.code[adunitId]
                }
            } else {
                toPush.mediaTypes.banner = { sizes: bannerSizes }
            }

            const ext = this.addGPID(adunitId)
            if (ext) toPush.ortb2Imp = ext

            preSlots.push(toPush)
        }

        return Promise.resolve(preSlots)
    }


}